import { MINIMUM_CLUSTER_SIZE, RESEAU_FROM_VENTES_RESEAUX, FACES_FROM_VENTES_RESEAUX, PANNEAUX_FROM_VENTES_LC, PANNEAUX_FROM_VENTES_NUMERIQUES, MARKER_POINT_DEFAUT } from '@/configuration/carteConf';
import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import { iconColorGetter, TAILLE_ICON_GRAND, TAILLE_ICON_PETIT } from '@/services/general/iconColorGetter';
import { isValidLat, isValidLng } from '@/services/general/gestionLatLng';
import { multiMarkerReseaux, typesInformationsReseaux } from '../decorateur/decorateurMarkersReseaux';
import { multiMarkerPanneaux, typesInformationsPanneaux } from '../decorateur/decorateurMarkersPanneaux';
import { multiMarkerPanneauxNumerique, typesInformationsPanneauxNumerique } from '../decorateur/decorateurMarkersPanneauxNumerique';
import { multiMarkerFacesFromReseaux, typesInformationsFacesFromReseaux } from '../decorateur/decorateurMarkersFacesReseaux';

export default function fromTypeToMarkers(nomType, listeType, afficherAzimut) {
  const dictionaryMarker = [];
  listeType.forEach(type => {
    if (isValidLat(type.latitude) && isValidLng(type.longitude)) {
      const clePosition = type.latitude + '|' + type.longitude;
      if (!dictionaryMarker[clePosition]) {
        dictionaryMarker[clePosition] = {
          position: { lat: type.latitude, lng: type.longitude },
          selected: false,
          surface: 0,
          color: niveauDispo.COULEUR_DISPO_INCONNU,
          icon: MARKER_POINT_DEFAUT,
        };
        if (nomType === RESEAU_FROM_VENTES_RESEAUX) {
          multiMarkerReseaux(dictionaryMarker, clePosition);
        } else if (nomType === PANNEAUX_FROM_VENTES_LC) {
          multiMarkerPanneaux(dictionaryMarker, clePosition, niveauDispo, MINIMUM_CLUSTER_SIZE);
        } else if (nomType === FACES_FROM_VENTES_RESEAUX) {
          multiMarkerFacesFromReseaux(dictionaryMarker, clePosition);
        } else if (nomType === PANNEAUX_FROM_VENTES_NUMERIQUES) {
          multiMarkerPanneauxNumerique(dictionaryMarker,
            clePosition,
            niveauDispo,
            MINIMUM_CLUSTER_SIZE);
        }
      }
      if (nomType === RESEAU_FROM_VENTES_RESEAUX) {
        typesInformationsReseaux(dictionaryMarker, clePosition,
          type);
      } else if (nomType === PANNEAUX_FROM_VENTES_LC) {
        typesInformationsPanneaux(dictionaryMarker, clePosition,
          type, niveauDispo);
      } else if (nomType === FACES_FROM_VENTES_RESEAUX) {
        typesInformationsFacesFromReseaux(dictionaryMarker, clePosition,
          type);
      } else if (nomType === PANNEAUX_FROM_VENTES_NUMERIQUES) {
        typesInformationsPanneauxNumerique(dictionaryMarker, clePosition, type, niveauDispo);
      }
    }
  });
  Object.values(dictionaryMarker).forEach(emplacement => {
    let taille = TAILLE_ICON_PETIT;
    if (emplacement.surface > 4.0) {
      taille = TAILLE_ICON_GRAND;
    }
    emplacement.icon = iconColorGetter(emplacement.color, taille,
      emplacement.azimut, afficherAzimut);
  });
  return Object.values(dictionaryMarker);
}



// WEBPACK FOOTER //
// ./src/services/catalogue/fromTypeToMarkers.js